import {
  AuthActionsType,
  ERROR_LOGIN_SET,
  FINISH_AUTHORIZATION,
  SET_BOT_AVATARS,
  SET_VIDEO_AVATARS,
  SET_EMAIL_NOT_VERIFIED,
  SET_SITE_SETTINGS,
  SET_USER,
  SET_USER_AVATARS,
  SET_USER_DATA,
  SET_USER_GROUPS,
  SET_VERIFICATION_EMAIL,
  SET_VERIFICATION_EMAIL_SENT,
  UPDATE_BOT_AVATAR,
  UPDATE_USER_AVATAR,
  UPDATE_VIDEO_AVATAR
} from './actions';
import {IAuthActionHandlerProps, IAuthInitialState, IAvatar, ISiteSettings, IUser, IVideoAvatar} from './interfaces';
import {IUserGroup, IUserProfile} from '@wholesalechange/chatcomponent';
import auth0Instance from 'utils/auth0/auth0Client';

const authInitialState: IAuthInitialState = {
  auth0Client: auth0Instance,
  auth0User: null,
  userProfile: null,
  botAvatars: null,
  userAvatars: null,
  videoAvatars: null,
  isFinishAuthorization: false,
  relogin: false,
  userGroups: [],
  settings: null,
  emailNotVerified: false,
  verificationEmail: null,
  verificationEmailSent: false
};

function setUser({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    auth0User: payload as IUser || null
  };
}

function setUserProfile({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    userProfile: payload as IUserProfile || null
  };
}

function setBotAvatars({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    botAvatars: payload as IAvatar[] || null
  };
}

function setVideoAvatars({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    videoAvatars: payload as IVideoAvatar[] || null
  };
}

function setUserAvatars({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    userAvatars: payload as IAvatar[] || null
  };
}

function setSiteSettings({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    settings: payload as ISiteSettings || null
  };
}

function updateUserAvatarValue({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  const data = payload as IAvatar;

  return {
    ...state,
    userAvatars: state.userAvatars?.map(avatar => {
      if (avatar.id === data.id) {
        return {
          ...avatar,
          fileUrl: data.fileUrl
        };
      }

      return avatar;
    }) || [data]
  };
}

function updateBotAvatarValue({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  const data = payload as IAvatar;

  return {
    ...state,
    botAvatars: state.botAvatars?.map(avatar => {
      if (avatar.id === data.id) {
        return {
          ...avatar,
          fileUrl: data.fileUrl
        };
      }

      return avatar;
    }) || [data]
  };
}

function updateVideoAvatarValue({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  const data = payload as IVideoAvatar;

  return {
    ...state,
    videoAvatars: state.videoAvatars?.map(avatar => {
      if (avatar.id === data.id) {
        return {
          ...avatar,
          fileUrl: data.fileUrl
        };
      }

      return avatar;
    }) || [data]
  };
}

function finishAuthorization({
  state
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    isFinishAuthorization: true
  };
}

function setUserGroups({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    userGroups: payload as IUserGroup[]
  };
}

function setEmailNotVerified({
  state
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    emailNotVerified: true
  };
}

function setVerificationEmail({
  state,
  payload
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    verificationEmail: payload as string
  };
}

function setVerificationEmailSent({
  state
}: IAuthActionHandlerProps): IAuthInitialState {
  return {
    ...state,
    verificationEmail: null,
    verificationEmailSent: true
  };
}

const authReducerHandlers = new Map([
  [SET_USER, setUser],
  [ERROR_LOGIN_SET, setUser],
  [SET_USER_DATA, setUserProfile],
  [SET_BOT_AVATARS, setBotAvatars],
  [SET_VIDEO_AVATARS, setVideoAvatars],
  [SET_USER_AVATARS, setUserAvatars],
  [UPDATE_USER_AVATAR, updateUserAvatarValue],
  [UPDATE_BOT_AVATAR, updateBotAvatarValue],
  [UPDATE_VIDEO_AVATAR, updateVideoAvatarValue],
  [FINISH_AUTHORIZATION, finishAuthorization],
  [SET_SITE_SETTINGS, setSiteSettings],
  [SET_USER_GROUPS, setUserGroups],
  [SET_EMAIL_NOT_VERIFIED, setEmailNotVerified],
  [SET_VERIFICATION_EMAIL, setVerificationEmail],
  [SET_VERIFICATION_EMAIL_SENT, setVerificationEmailSent]
]);

const authReducer = (state = authInitialState, action: AuthActionsType): IAuthInitialState => {
  const handler = authReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<IAuthActionHandlerProps>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default authReducer;

